import { render, staticRenderFns } from "./OralExpressionF.vue?vue&type=template&id=1929eca4&scoped=true&"
import script from "./OralExpressionF.vue?vue&type=script&lang=js&"
export * from "./OralExpressionF.vue?vue&type=script&lang=js&"
import style0 from "./OralExpressionF.vue?vue&type=style&index=0&id=1929eca4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1929eca4",
  null
  
)

export default component.exports